import { DeepPartial, PopularSearchesConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_POPULAR_SEARCHES_CONFIG: DeepPartial<PopularSearchesConfig> = {
  size: 5
};
